export const isObject = (value: unknown): value is object => {
  if (value === null || value === undefined || Array.isArray(value)) {
    return false;
  }

  return typeof value === 'object';
};
